import React from "react";
import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";
import { number } from "prop-types";

import {
  CONTACTS_IMAGE_HEIGHT,
  CONTACTS_IMAGE_QUALITY,
  CONTACTS_IMAGE_WIDTH
} from "../../constants/contacts";
import * as S from "./styled";

export const VIEWER_QUERY = gql`
  {
    viewer {
      name
      email
      phone
    }
  }
`;

export const CONTACTS_QUERY = gql`
  query rental_contacts(
    $rental_id: ID!
    $width: Int!
    $height: Int!
    $quality: Int!
  ) {
    rental_contacts(input: { rental_id: $rental_id }) {
      business_name
      image {
        url(width: $width, height: $height, quality: $quality)
      }
      industry_professional {
        headshot {
          url(width: $width, height: $height, quality: $quality)
        }
      }
      id
      name
      phone
      account_url
      license {
        id
        display_type
      }
    }
  }
`;

export const RENTAL_QUERY = gql`
  query rental($id: ID!) {
    rental(id: $id) {
      id
      address {
        unit
      }
      title_with_unit
      listed_price
      anyrooms_description
      bedrooms_description
      baths_description
      building {
        url
      }
      source
    }
  }
`;

const RentalContactQuery = ({ children, listingId }) => {
  const userInfoStoredInBrowser = sessionStorage.getItem("viewer");

  const {
    loading: loadingViewerData,
    data: viewerData = { viewer: {} }
  } = useQuery(VIEWER_QUERY, { skip: Boolean(userInfoStoredInBrowser) });

  const {
    data: rentalData,
    error: rentalError,
    loading: loadingRentalData
  } = useQuery(RENTAL_QUERY, {
    variables: { id: listingId }
  });

  const {
    loading: loadingContactsData,
    data: contactsData = { rental_contacts: [] }
  } = useQuery(CONTACTS_QUERY, {
    variables: {
      rental_id: listingId,
      width: CONTACTS_IMAGE_WIDTH,
      height: CONTACTS_IMAGE_HEIGHT,
      quality: CONTACTS_IMAGE_QUALITY
    }
  });

  if (loadingViewerData || loadingRentalData || loadingContactsData) {
    return <S.Loading>Loading...</S.Loading>;
  }

  if (rentalError) {
    return "There's been an Error";
  }

  const userData = userInfoStoredInBrowser
    ? { viewer: JSON.parse(userInfoStoredInBrowser) }
    : viewerData;

  if (userData?.viewer?.email?.includes("@privaterelay")) {
    userData.viewer.email = "";
  }

  return children({ data: { ...rentalData, ...userData, ...contactsData } });
};

RentalContactQuery.propTypes = {
  listingId: number.isRequired
};

export default RentalContactQuery;
